import { extendServiceContainer } from '@iotize/tap';
import { BleService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    ble: BleService;
  }
}

export const _TAP_SERVICE_EXTENSION_BLE_ = extendServiceContainer(
  'ble',
  BleService,
);
